import { Injectable } from '@angular/core';
import { toast } from 'ngx-sonner';
import { CustomToastComponent } from '../../shared/components/ui/custom-toast/custom-toast.component';
import { ErrorIconComponent } from '../../shared/components/ui/sonner-icons/error-icon.component';
import { InfoIconComponent } from '../../shared/components/ui/sonner-icons/info-icon.component';
import { SuccessIconComponent } from '../../shared/components/ui/sonner-icons/success-icon.component';

type ToastOptions = {
  position?: string;
  description?: string;
};

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastComponent = CustomToastComponent;
  constructor() {}

  warning(title: string, props?: ToastOptions) {
    const componentProps = {
      title: title,
      type: 'warning',
      duration: 5000,
      icon: ErrorIconComponent,
    };
    toast.custom(this.toastComponent, {
      componentProps: { ...componentProps, ...props },
    });
  }

  info(title: string, props?: ToastOptions) {
    const componentProps = {
      title: title,
      type: 'info',
      duration: 5000,
      icon: InfoIconComponent,
    };
    toast.custom(this.toastComponent, {
      componentProps: { ...componentProps, ...props },
    });
  }

  success(title: string, props?: ToastOptions) {
    const componentProps = {
      title: title,
      type: 'success',
      duration: 5000,
      icon: SuccessIconComponent,
    };
    toast.custom(this.toastComponent, {
      componentProps: { ...componentProps, ...props },
    });
  }

  error(title: string, props?: ToastOptions) {
    const componentProps = {
      title: title,
      type: 'error',
      duration: 5000,
      icon: ErrorIconComponent,
    };
    toast.custom(this.toastComponent, {
      componentProps: { ...componentProps, ...props },
    });
  }
}
